import { Injectable } from '@angular/core';

export type PortalType = 'admin' | 'business' | 'franchise';

@Injectable({ providedIn: 'root' })
export class PortalContextService {
  readonly portal = this.detectPortal();

  get isDedicatedHost(): boolean {
    return this.hostname.split('.').some((label) => label === 'admin' || label === 'partner' || label === 'business' || label === 'franchise');
  }

  get loginRoute(): string {
    return '/login';
  }

  get dashboardRoute(): string {
    return this.portal === 'admin' ? '/admin/dashboard' : this.portal === 'franchise' ? '/franchise/dashboard' : '/business/dashboard';
  }

  storageKey(key: string): string {
    return `zepbazaar_${this.portal}_${key}`;
  }

  userPortal(user: { tenantId?: string | null; roles?: string[]; permissions?: string[] }): PortalType {
    if (!user.tenantId) return 'admin';
    if (!(user.roles?.length) && !(user.permissions?.length)) return 'franchise';
    return 'business';
  }

  private get hostname(): string {
    return typeof window === 'undefined' ? '' : window.location.hostname.toLowerCase();
  }

  private detectPortal(): PortalType {
    const labels = this.hostname.split('.');
    if (labels.includes('admin')) return 'admin';
    if (labels.includes('franchise')) return 'franchise';
    if (labels.includes('partner') || labels.includes('business')) return 'business';
    return 'admin';
  }
}
